import React, {useMemo} from "react";
import {
    withNamespaces,
} from "react-i18next";

import {
    baseTariff,
    forwarderTariff,
} from "../../content/tariffs";
import TariffCard from "./TariffCard";
import TariffConstructor from "./TariffConstructor";
import TrialBanner from "./TrialBanner";
import "./style.less";

const PRICE_LOCALES = {
    ru: "ru-RU",
    en: "en-US",
    cn: "zh-CN",
};

export function TariffsSection({
    t,
    i18n,
}) {
    const priceFormatter = useMemo(
        () =>
            new Intl.NumberFormat(
                PRICE_LOCALES[
                    i18n.language
                ] ||
                    PRICE_LOCALES.ru
            ),
        [i18n.language]
    );

    const formatPrice = (price) =>
        `${priceFormatter.format(
            price
        )} ₽`;

    return (
        <section
            className="landing-tariffs landing-section landing-section--middle"
            id="tariffs"
        >
            <div className="landing-tariffs__decoration landing-tariffs__decoration--left"/>

            <div className="landing-tariffs__decoration landing-tariffs__decoration--right"/>

            <div className="container public-site-shell">
                <div className="landing-tariffs__heading landing-section-heading">
                    <div>
                        <span className="landing-tariffs__eyebrow landing-section-heading__eyebrow">
                            {t(
                                "main.landing.tariffs.eyebrow"
                            )}
                        </span>

                        <h2 className="landing-tariffs__title landing-section-heading__title">
                            {t(
                                "main.landing.tariffs.title"
                            )}
                        </h2>
                    </div>

                    <p className="landing-tariffs__intro landing-section-heading__intro">
                        {t(
                            "main.landing.tariffs.intro"
                        )}
                    </p>
                </div>

                <TrialBanner t={t}/>

                <div className="landing-tariffs__cards">
                    <TariffCard
                        tariff={
                            baseTariff
                        }
                        formatPrice={
                            formatPrice
                        }
                        t={t}
                    />

                    <TariffCard
                        tariff={
                            forwarderTariff
                        }
                        formatPrice={
                            formatPrice
                        }
                        t={t}
                    />
                </div>

                <TariffConstructor
                    formatPrice={
                        formatPrice
                    }
                    t={t}
                />
            </div>
        </section>
    );
}

export default withNamespaces(
    "translation"
)(TariffsSection);
